import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { CompletedPaymentInModel } from '../../Models/Models/Payments/Deposits/CompletedPaymentInModel';
import { IJsonDate } from '../../System/IJsonDate';

declare var IS_RUNNING_IN_APP_POOL;

export class CompletedProductPaymentsInClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(subAccountHierarchyId: string, fromDate: IJsonDate, fromInception: boolean): Promise<Array<CompletedPaymentInModel>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Payments/CompletedProductPaymentsIn/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { subAccountHierarchyId: subAccountHierarchyId, fromDate: fromDate, fromInception: fromInception }

    return AjaxWrapper.get<Array<CompletedPaymentInModel>, any>(url, data);
  }
}

